<template>
<DBox
  :id="'cmp-distribution-accounts-account_sidewindow-import-setup'"
  :addButton="false"
  :addLink="true"
  :rightMenu="[]"

  :addLinkLabel="`${$t('add_new')} ${$t('')}`"
  @add_click="onAddClick"
>
    <NTable 
      :id="'distribution-accounts-account_sidewindow-current_statement_list'" 
      class="dbox1"
      :headers="headers" 
      :items="list" 
      :config="tableConfig"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('statement_setup')">
              <span @click="onEditClick(item)" class="ut-link ut-text-accent5"> {{item['description']}}</span>
          </td>
          <td v-bind="tdcon('period')">
            <span> {{item['statement_period']}}</span>
          </td>

          <td v-bind="tdcon('type')">
            <span> {{item['digital_physical']}}</span>
          </td>
          <td v-bind="tdcon('currency')">
             <span>{{item['currency']}}</span>
          </td>

          <!-- <td v-bind="tdcon('country')">
            <span>{{item['fix_country']}}</span>
          </td>
          <td v-bind="tdcon('shop')">
            <span>{{item['fix_shop']}}</span>
          </td> -->

          <td v-bind="tdcon('distribution_fee')">
            <span v-if="item['distribution_fee_sales'] && item['distribution_fee_returns']">{{item['distribution_fee_sales']}}%  {{item['distribution_fee_returns']}}%</span>
          </td>
          <td v-bind="tdcon('dss')">
               <Dropdown2
                  id="dss_id"
                  :label="''"
                  :showLabel="false"
                  :placeholder="$dft.capHead($t('dss'))"
                  :disabled="false"
                  :options="dssTV"
                  deselect
                  :selected="dssTV.find(
                    (e) => e.value == item.dss_id
                  )
                "
                :bb="'none'"
                v-on:selectedChange="(e) => onDropdownChange('dss_id', e,item)"
              />
          </td>

          <td v-bind="tdcon('active')">
            <div class="ut-flex">
              <div class="dt-checkbox v2 s1 ">
                <input
                  class="disabled"
                  type="checkbox"
                  :checked="item['active_flag']"
                  @click="e => onCheckBoxChange(e, item)"
                />
                <div class="checkmark"></div>
                
              </div>
            </div>
          </td>
          <td v-bind="tdcon('rounding_difference')">
            <span class="ut-link ut-text-accent5" @click="onPerformClick(item)">{{ $t('perform') }}</span>
          </td>

          <td v-bind="tdcon('options')" class="print">
            <img src="static/icons/delete.svg" class="dt-icon v5" @click="(e) => onDeleteImportSetup(item)" alt="Delete Import Setup" title="Delete Import Setup" />
          </td>
        </tr>
      </template>
    </NTable>
</DBox>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
import Dropdown from "../../../../plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import { createModalMixin, openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import AddCurrentStatement from "./add-current-statement";
import { addRemoveSet } from '../../../../utility';
import { ConfirmationService, createConfirmResult } from '../../../../dt-plugins/confirmation/confirmation.service';
import { async } from 'ramda-adjunct';
import { createTV } from '../../../../models/text-value.model';

export default {
  components: {
    NTable,
    TextInput,
    AddCurrentStatement,
  },
  props: {
    selectedAccountsDetails: {
      type: Object
    }
  },
  data: function () {
    return {
 
      selectedStatementIDs: new Set(),
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
        key: "currentStatementList",
      }),
      addCurrentStatementModalContainer: false,
    };
  },
  computed: {
    list: function() {
      return this.selectedAccountsDetails?.statement_settings
    },

    dssTV:function(){
      return createTV(this.selectedAccountsDetails?.dss_list||[],"dss_name","dss_id");
    },


    headers: function () {
      return [
        createTableHeader("statement_setup", { f:1.3 }),//120
        createTableHeader("period",{ mw:70}),
        createTableHeader("type",{ mw:120}),
        createTableHeader("currency",{ mw:65 }),
        // createTableHeader("country",{ mw:85 }),
        // createTableHeader("shop",{mw:90}),
        createTableHeader("distribution_fee",{mw:130}),
        createTableHeader("dss",{  f:1.5 }),//170
        createTableHeader("active",{mw:50 ,ta:'center'}),
        createTableHeader("rounding_difference",{text:false,mw:100}),

        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  //mixins: [createModalMixin("addCurrentStatement")],
  methods: {
    onAddCurrentStatementCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          account_id: undefined,
          external_table: undefined,
        },
      });
    },
    onCurrentStatementAdded: function (statements) {
      this[ActionTypes.CURRENT_STATEMENT.SET.ALL](statements);
      this.onAddCurrentStatementCancelled();
    },
    onDeleteImportSetup: function (item) {
       
       this.$emit("delete",item)

      //this[ActionTypes.CURRENT_STATEMENT.DELETE.SINGLE]({ statement_id: item.statement_id });
    },
    onAddClick:function(){
      this.$router.push({
        ...this.$route,
        query: {
          modal: "import_setup_modal",
          account_id: this.selectedAccountsDetails?.account?.account_id,
          account_name:this.selectedAccountsDetails?.account?.account_name,
          mode:'add'
        }
      });
    },

    onEditClick:function(item){

      console.log(":::::::",item);
      this.$router.push({
        ...this.$route,
        query: {
          modal: "import_setup_modal",
          account_id: this.selectedAccountsDetails?.account?.account_id,
          account_name:this.selectedAccountsDetails?.account?.account_name,
          statement_setting_id:item.statement_setting_id,
          mode:'edit'
        }
      });
    },

    onPerformClick:function(item){
      this.$router.push({
        ...this.$route,
        query: {
          modal: "perform_modal",
          account_id: this.selectedAccountsDetails?.account?.account_id,
          account_name:this.selectedAccountsDetails?.account?.account_name,
          statement_setting_id:item.statement_setting_id,
         
        }
      });
    },
    
    onCheckBoxChange:async function(e, item) {
      const value = e.target.checked?1:'';
      const payload = { name:'active_flag' , value:value ,kVal:item.statement_setting_id ,account_id:item.account_id};
      this.$emit("update",payload);
    },

    onDropdownChange:function(name,e,item){
      const value = e.value?e.value:""
      console.log(item,"::::::::::::::::")
      console.log(value,"111::::::::::::::::")
      const payload = { name:name , value:value ,kVal:item.statement_setting_id ,account_id:item.account_id};
      this.$emit("update",payload);
    }
  },
};
</script>

<style lang="scss">
.cmp-distribution-accounts-account_sidewindow-current_statement_list {
  .current-statement-list {
    --ntable-height: 320px !important;
    th:nth-child(2),
    th:nth-child(8) {
      min-width: max-content;
    }
    td:nth-child(2),
    th:nth-child(8) {
      min-width: max-content;
    }
    tr {
      padding-left: 5px;
      td {
        margin-right: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: flex;
      }
    }
  }
}
</style>